


































import { Vue, Component, Prop } from 'vue-property-decorator';
import Container from '../../Registration/v2/Container.vue';
import RegistrationCard from '../../Registration/v2/Card.vue';
import CardHeader from '../../Registration/v2/Header.vue';
import SsoLogin from '../../Registration/v2/SsoLogin.vue';
import VerifyAccountForm from './VerifyAccount.vue';
import { AuthParams } from '@/models/userdata/authparams';
import { OAuthPassport } from '@/models/userdata/socialauthparams';
import { vxm } from '@/store.vuex';
import router from 'router';
declare var window: any;

@Component({
  components: {
    Container,
    RegistrationCard,
    CardHeader,
    SsoLogin,
    VerifyAccountForm,
  },
})
export default class Login extends Vue {
  @Prop() sessionExpired;
  private emailRegex: RegExp = vxm.utility.emailRegex;
  private authParams: AuthParams = new AuthParams();
  private errorString: string = '';
  private isMobileScreen: boolean = false;
  $wlToastr: any;
  private errors = { username: '', socialmMedia: '' };

  beforeMount() {
    if (this.$route.query.token + '') {
      vxm.utility.setUserDeviceToken(this.$route.query.token);
    }
    if (vxm.users.isLoggedIn) {
      const queryParams = this.$route.query;
    const isTrackable = queryParams.hasOwnProperty('utm_source');
      var jid= this.$route.params.JobID

  if(jid &&queryParams.hasOwnProperty('utm_source')|| queryParams.hasOwnProperty('utm_campaign') || queryParams.hasOwnProperty('utm_medium')){
    
    this.$router.push({path: '/jobdetails/'+jid,query: queryParams})

  }
  else if(jid){
    this.$router.push('/jobdetails/'+jid)
    }
  else{
      this.$router.push('/')
  }
    }
  }

  onContinue() {
    if (localStorage && localStorage.getItem('sender_id')) {
      localStorage.removeItem('sender_id');
    }
    this.authParams.companyCode = this.$store.state.jobs.companyCode;
    if (this.validateData(this.authParams)) {
      const responsePromise = vxm.users
        .verifyAccount(this.authParams.username)
        .then(resp => {
          if (resp && resp.accountEnabled === false) {
            this.$router.push({ name: 'AccountDisabled' });
            return;
          }
          if (vxm.users.isSocialMediaRegisterd) {
            this.errors.socialmMedia =
              'forgotpassword.socialmedia.errormessage';
          } else {
            if (
              vxm.configs.getGlobalConfigValue('SKIP_GSU_ON_REGISTRATION_FOR_USERS_ONFILE') &&
              resp.accountRegistrationStatus.registrationCode != '90' &&
              resp.customFields &&
              resp.customFields.candidateCustomMetaData &&
              resp.customFields.candidateCustomMetaData.length > 0 &&
              resp.customFields.candidateCustomMetaData[0].label ==
                'Application On File' &&
              resp.customFields.candidateCustomMetaData[0].defaultValue &&
              resp.customFields.candidateCustomMetaData[0].defaultValue.toLowerCase() ==
                'yes'
            ) {
              vxm.jobs.setSkipGuidedSignUpOnRegistration(true);
            }
            this.$router.push({
              name: vxm.users.getRouteAfterUniversalLogin,
            });
          }
        });
    }
  }

  validateData(authParams: AuthParams): boolean {
    let formValid = true;
    this.errors = { username: '', socialmMedia: '' };
    if (!this.emailRegex.test(authParams.username)) {
      this.errors.username = 'login.email.invalid';
    }
    if (!authParams.username) {
      this.errors.username = 'login.v2.email.required';
    }

    Object.keys(this.errors).forEach((field) => {
      formValid = formValid && !this.errors[field];
    });
    return formValid;
  }

  getOAuthProvider(): string {
    return this.$cookies.get('OAuthProvider');
  }

  loginWithApple() {
    this.$cookies.set('OAuthProvider', 'apple', 300);
    return vxm.users.loginWithApple();
  }

  facebookLogin() {
    this.$cookies.set('OAuthProvider', 'facebook', 300);
    return vxm.users.loginWithFacebook();
  }

  googleLogin() {
    this.$cookies.set('OAuthProvider', 'google', 300);
    return vxm.users.loginWithGoogle();
  }

  get showCancelButtonForSSO() {
    return !vxm.configs.getGlobalConfigBooelanValue('DEFAULT_CANDIDATE_LANDING_PAGE_AS_LOGIN')
  }

  get getCustomLoginTitle() {
    const customLoginTitle = vxm.configs.getGlobalConfigValue(
      'WL_CANDIDATE_PORTAL_WELCOME_SCREEN_TITLE',
    );
    if (customLoginTitle) return customLoginTitle;
    return this.$t('login.welcome_text.emailentry', {
      companyName: this.companyName,
    });
  }

  linkedinLogin() {
    this.$cookies.set('OAuthProvider', 'linkedin', 300);
    return vxm.users.loginWithLinkedin();
  }
  cancelLogin() {
    if (vxm.utility.UserDeviceToken) {
      const appurl = '/atsuser/regSuccess?success=false';
      (<any>window).location = appurl;
      return;
    }
    this.$router.push({ name: 'Findjobs' });
  }

  get companyName(): String {
    return vxm.utility.companyName;
  }

  mounted() {
    this.isMobileScreen = vxm.utility.isMobileDevice;
    // Signup Action: after quick apply
    var jid= this.$route.params.JobID
    if(jid){
    this.$cookies.set('SubmitJobApplicationId', jid, 600);
    var path='JobDetails:' + jid;
    this.$cookies.set('NavigateTo_ID', path, 600);
    this.$cookies.set('apply', true, 600);
  }
    const postQuickApplySignupAction = this.$route.params.postQuickApplySignupAction || String(this.$route.query.postQuickApplySignupAction) ;
    if (postQuickApplySignupAction && JSON.parse(postQuickApplySignupAction)) {
      this.authParams.username = String(this.$route.params.userName || this.$route.query.userName);
      this.onContinue();
      return;
    }

    if (this.sessionExpired) {
      this.$wlToastr(
        'info',
        'Your session has timed out. Please sign in again.',
        'Session Timeout',
      );
    }

    this.authParams.username = this.$cookies.get('userName');
    if (window.location.href.indexOf('?') >= 0)
      window.location.href
        .split('?')[1]
        .split('&')
        .forEach((elm) => {
          if (elm.indexOf('code') >= 0) {
            const token = elm.split('=')[1];
            console.log('token ', token);
            console.log('token', decodeURI(token));
            const ccode = decodeURI(token.replace('%2F', '/').replace('=', ''));
            console.log('this.getOAuthProvider()');
            console.log(this.getOAuthProvider());
            if (this.getOAuthProvider() === 'apple') {
              const oauthPassport = new OAuthPassport();
              oauthPassport.email = String(this.$route.query.email);
              oauthPassport.oAuthToken = String(ccode);
              oauthPassport.oAuthProvider = 'apple';
              vxm.users.socialLogin(oauthPassport);
            }

            if (this.getOAuthProvider() === 'facebook') {
              vxm.users.validateFacebookOAuthCode(ccode);
            }

            if (this.getOAuthProvider() === 'google') {
              vxm.users.validateGoogleOAuthCode(ccode);
            }

            if (this.getOAuthProvider() === 'linkedin') {
              vxm.users.validateLinkedinOAuthCode(ccode);
            }

            if (!this.getOAuthProvider()) {
              this.$router.push('login');
            }
          }
        });
  }
}
